import React, { useEffect, useState } from 'react';
import { Result, Tabs } from 'antd';
import HarcirahKabuk from './kabuk';
import HarcirahRapor from './HarcirahRapor';
import OnayKutusu from './OnayKutusu';
import { PersonelSekmesi } from './seyahat';
import { useHarcirahApi } from './ortak';

/**
 * Rol ekranları (30.10.2026 kullanıcı: "işlemler için ayrışmış ekran; rezervasyon, finans ve amir rapor göremeyecek"):
 *   /harcirah/finans  Finans — Kıdemli Finans Uzmanları, yönetim, 327 (30.10.2026; hepsi karar verir): seyahat fiyat onayı (kart limiti), harcama kontrolü, yemek finans onayı
 *   /harcirah/onay    Onaylarım — amir (plan + yemek harcırahı) ve yönetim (son onay / yönetici aşaması)
 *   /harcirah/rapor   Rapor — yönetim + Harcırah r: tamamı, ekip süzgeci ve Personel; amir: yalnız amiri olduğu seyahatler
 * Erişimi backend denetler (roller, /harcirah-onay?kapsam=, rapor kapsamı); rolü olmayana açıklama gösterilir.
 */
function Kapali({ metin }) {
  return <Result status="403" title="Bu ekran size kapalı" subTitle={metin} />;
}

export function HarcirahFinans() {
  return (
    <HarcirahKabuk baslik="Finans">
      {(r) => (r.finans ? <OnayKutusu kapsam="finans" /> : <Kapali metin="Finans ekranı Kıdemli Finans Uzmanlarına ve yönetime açıktır." />)}
    </HarcirahKabuk>
  );
}

export function HarcirahOnaylarim() {
  return (
    <HarcirahKabuk baslik="Onaylarım">
      {(r) => (r.onay ? <OnayKutusu kapsam="amir" /> : <Kapali metin="Onaylarım ekranı amirlere ve yönetime açıktır." />)}
    </HarcirahKabuk>
  );
}

function RaporSekmeleri({ tam }) {
  const api = useHarcirahApi();
  const [secenekler, setSecenekler] = useState(null);
  useEffect(() => { if (tam) api.get('/secenekler').then(setSecenekler).catch(() => {}); }, [api, tam]);
  if (!tam) return <HarcirahRapor />;  // amir: yalnız amiri olduğu seyahatler (backend zorlar)
  return (
    <Tabs type="card" destroyOnHidden items={[
      { key: 'rapor', label: 'Rapor', children: <HarcirahRapor /> },
      { key: 'personel', label: 'Personel', children: <PersonelSekmesi secenekler={secenekler} /> },
    ]} />
  );
}

export function HarcirahRaporEkrani() {
  return (
    <HarcirahKabuk baslik="Rapor">
      {(r) => (r.rapor ? <RaporSekmeleri tam={r.rapor === 'tam'} /> : <Kapali metin="Rapor yönetime ve amirlere açıktır." />)}
    </HarcirahKabuk>
  );
}
